module.exports = __webpack_public_path__ + "img/bj52.c302b2da.png";